<!-- Air Parking -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    <div [class.duplicate-item-wrapper]="duplicateBooking">
      @if (duplicateBooking) {
        <div class="duplicate-item-date">
          <i class="ico-parking ico-material"></i>&nbsp;
          @if (parking?.detail?.arrivalDatetime; as arrivalDatetime) {
            <span i18n="@@basketPanelParkingArrival">Check-in:</span>
            <strong>{{ arrivalDatetime | sabsDate: 5 }}</strong>
          }
          @if (parking?.detail?.departDatetime; as departDatetime) {
            <span i18n="@@basketPanelParkingDeparture">Check-out:</span>
            <strong>{{ departDatetime | sabsDate: 5 }}</strong>
          }
        </div>
      }

      <div [class.duplicate-item-info]="duplicateBooking">
        <div class="cart_item_heading">
          @if (!duplicateBooking) {
            <i class="ico-parking ico-material"></i>&nbsp;
          }
          <strong>{{ parking.detail.name }}</strong>
          @if (!duplicateBooking) {
            <section (mouseleave)="tt1.close()">
              <button
                class="cart_item_remove ico-trash"
                ngbTooltip="Remove {{ parking.detail.name }} from your {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                attr.aria-label="Remove {{ parking.detail.name }} parking from your {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-ngbTooltip
                (click)="remove.emit()"
                triggers="manual"
                #tt1="ngbTooltip"
                (mouseenter)="tt1.open()"
                (focus)="tt1.open()"
                (blur)="tt1.close()"
                id="remove-basketitem-{{ parking.id }}"
              ></button>
            </section>
          }
          @if (!duplicateBooking) {
            <section (mouseleave)="tt2.close()">
              <img
                src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                  displayItinerary ? 'luggage_icon' : 'basket_move'
                }}.svg"
                class="move_basket_icon"
                role="button"
                ngbTooltip="Move to different {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-ngbTooltip
                attr.aria-label="Move {{ parking.detail.name }} parking to different {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-aria-label
                (click)="openChangeModal.emit()"
                (keydown.enter)="openChangeModal.emit()"
                (keydown.space)="openChangeModal.emit()"
                triggers="manual"
                #tt2="ngbTooltip"
                (mouseenter)="tt2.open()"
                (focus)="tt2.open()"
                (blur)="tt2.close()"
                tabindex="0"
                id="share-basketitem-{{ parking.id }}"
              />
            </section>
          }
        </div>
        @if (parking.searchQuery.locationCode) {
          <div
            class="cart_item_destination"
            id="parking-{{ displayItinerary ? 'itinerary' : 'basket' }}-dest-{{ itemIndex }}"
          >
            <span i18n="@@ParkingSearchAirport">Airport:</span>
            {{
              parking.searchQuery.airportFullName
                ? parking.searchQuery.airportFullName +
                  ' (' +
                  parking.searchQuery.locationCode +
                  ')'
                : (parking.searchQuery.locationCode | airportIata | async)
            }}
          </div>
        }
        @if (parking.searchQuery.terminal) {
          <div class="cart_item_destination">
            <span i18n="@@parkingBasketTerminal">Terminal:</span>
            {{ getTerminal(parking.searchQuery.terminal) | translate }}
          </div>
        }
      </div>
    </div>
    @if (!duplicateBooking) {
      @if (parking?.detail?.arrivalDatetime; as arrivalDatetime) {
        <div class="cart_item_dates">
          <span i18n="@@basketPanelParkingArrival">Check-in:</span>
          {{ arrivalDatetime | sabsDate: 5 }}
        </div>
      }
      @if (parking?.detail?.departDatetime; as departDatetime) {
        <div class="cart_item_dates">
          <span i18n="@@basketPanelParkingDeparture">Check-out:</span>
          {{ departDatetime | sabsDate: 5 }}
        </div>
      }
    }
    @if (!duplicateBooking) {
      @for (user of travellers; track user) {
        <div class="traveller-name">
          <b>{{ user.forename }}, {{ user.surname }}</b>
        </div>
      }
    }
    <div class="cart_item_price">
      @if (duplicateBooking) {
        <strong i18n="@@basketPanelParkingCost">Cost</strong>
      }
      <strong>{{ parking.price | currency: parking.currency }}</strong>
      @if (!duplicateBooking) {
        <em i18n="@@basketPanelParkingTotalPrice">&nbsp;Total Price</em>
      }
    </div>
  </div>
</div>
